module.exports = __webpack_public_path__ + "static/media/dark_right_angle.0065d4eb.svg";